import { useQuery } from "@tanstack/react-query";
import { fetchAffiliateAnalyticsSummary, fetchAffiliateAnalyticsTimeseries } from "../utils/affiliateApi";

export const useAffiliateAnalyticsSummary = ({ start_date = null, end_date = null, coupon_ids = [], enabled = true } = {}) => {
  return useQuery({
    queryKey: ["affiliate", "analytics", "summary", { start_date, end_date, coupon_ids }],
    queryFn: () => fetchAffiliateAnalyticsSummary({ start_date, end_date, coupon_ids }),
    enabled,
    refetchOnWindowFocus: false,
  });
};

export const useAffiliateAnalyticsTimeseries = ({
  granularity,
  start_date = null,
  end_date = null,
  coupon_ids = [],
  enabled = true,
} = {}) => {
  return useQuery({
    queryKey: ["affiliate", "analytics", "timeseries", { granularity, start_date, end_date, coupon_ids }],
    queryFn: () => fetchAffiliateAnalyticsTimeseries({ granularity, start_date, end_date, coupon_ids }),
    enabled: enabled && !!granularity,
    refetchOnWindowFocus: false,
  });
};


